var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('reseller-form',{attrs:{"loading":_vm.loading,"resellerData":_vm.reseller,"formErrors":_vm.formErrors},on:{"resellerSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }